/**
 * Cookie 生成模块
 * 移植自 xhshow-go/xhshow/cookie_gen.go
 */

const CHARSET = 'abcdefghijklmnopqrstuvwxyz1234567890';

/**
 * 生成随机字符串
 */
export function generateRandomString(length: number): string {
  let result = '';
  for (let i = 0; i < length; i++) {
    result += CHARSET[Math.floor(Math.random() * CHARSET.length)];
  }
  return result;
}

/**
 * 生成 WebId (32 字符的十六进制字符串)
 */
export function registerId(): string {
  const hexChars = 'abcdef0123456789';
  let result = '';
  for (let i = 0; i < 32; i++) {
    result += hexChars[Math.floor(Math.random() * hexChars.length)];
  }
  return result;
}

/**
 * 生成 A1 Cookie 值
 */
export function generateA1(): string {
  const a = 5;

  // 当前时间戳（毫秒）转十六进制
  const ts = Date.now();
  const o = ts.toString(16);

  const n = o + generateRandomString(30);
  const r = n + a.toString();
  const e = r + '0';
  const u = e + '000';

  // 计算 CRC32
  const crc32Value = crc32(Buffer.from(u));

  let result = u + crc32Value.toString();

  // 截断到 52 字符
  if (result.length > 52) {
    result = result.substring(0, 52);
  }

  return result;
}

/**
 * 获取加载时间戳（毫秒）
 */
export function getLoadTs(): string {
  return Date.now().toString();
}

/**
 * CRC32 计算（标准 IEEE 多项式）
 */
function crc32(buffer: Buffer): number {
  let crc = 0xffffffff;
  for (let i = 0; i < buffer.length; i++) {
    crc ^= buffer[i];
    for (let j = 0; j < 8; j++) {
      crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1));
    }
  }
  return (crc ^ 0xffffffff) >>> 0;
}
